import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
displayShare!:boolean;
share_item_image_url='';
share_item_name='';
share_link='';
 
}
